<script>
import axios from 'axios';
import { formatCurrency } from "@/helpers/function";
import { usePermissions } from '@/composables/usePermissions';

export default {

    props: {
        cust_id :{
            type : Number,
        },
        order_id :{
            type : Text,
        }
    },

    data() {
        return {
            Collection:[],
            outstanding_amount:'',
            late_payment:'',
            unresolved_invoice:'',
            totalUnbillAmount: '',
            over_pay:'0.00',
        }
    },
  setup() {
        const {
            canReadCustomers,
            canCreateInvoices,
            canCreateCreditNotes,
            canCreateRefunds,
            canReadAgingReport,
            canCreateInstantPay,
            arPermissions
        } = usePermissions()
        return {
            canReadCustomers,
            canCreateInvoices,
            canCreateCreditNotes,
            canReadAgingReport,
            canCreateRefunds,
            canCreateInstantPay,
            arPermissions
        };
    },
    methods:{
        getdashboarddata(cust_id){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'dashboard/customer/info/'+cust_id)
            .then(response => {
                if (response) {
                    this.outstanding_amount = response.data.total_outstanding_amount;
                    this.late_payment = response.data.total_late_payment;
                    this.unresolved_invoice = response.data.total_unresolved_invoice;
                    this.over_pay = response.data.total_over_pay.balance_amount;
                    this.totalUnbillAmount = response.data.total_unbilled_amount;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        formatCurrency,
    },
    mounted() {
        this.getdashboarddata(this.cust_id);
    }
}
</script>

<template>
    <div class="row align-items-stretch">
        <div class="col-xl-3">
            <div class="card card-animate flex-fill h-100">
                <div class="card-body d-flex flex-column">
                    <p class="align-items-center text-uppercase fw-medium text-muted text-truncate mb-3" style="font-size: 16px;">
                        TOTAL OUTSTANDING AMOUNT
                    </p>
                    <div class="row d-flex align-items-center mb-3">
                        <!-- <div class="col-sm-8"></div> -->
                        <div class="col-sm-12">
                        <h4 class="fs-4 flex-grow-1 mb-0 text-end">
                            <span class="counter-value"> {{ formatCurrency(outstanding_amount) }}</span>
                        </h4>
                        </div>
                        <div class="col-sm-12 mt-2">
                            <div class="row">
                                <div class="col-sm-12 text-end">unbilled amount: {{ formatCurrency(totalUnbillAmount) }}</div>
                            </div>
                        </div>
                    </div>
                    <router-link
                    :to="'/ar/instantpay/' + cust_id"
                    custom
                    v-slot="{ navigate, href }"
                    >
                    <button
                        :disabled="!canCreateInstantPay"
                        class="mt-auto w-100 btn-lg"
                        :class="canCreateInstantPay ? 'mt-auto w-100 btn-lg btn btn-success' : 'mt-auto w-100 btn-lg btn btn-success disabled opacity-50'"
                        style="font-size: 16px;"
                        :href="href"
                        @click="navigate"
                    >
                        Add Payment
                    </button>
                    </router-link>
                </div>
                <!-- end card body -->
            </div>
        </div>

        <div class="col-xl-3">
            <div class="card card-animate flex-fill h-100">
                <div class="card-body d-flex flex-column">
                    <p class="align-items-center text-uppercase fw-medium text-muted text-truncate mb-3" style="font-size: 16px;">
                        Unresolved Monthly Statement
                    </p>
                    <div class="row d-flex align-items-center mb-3">
                        <div class="col-sm-12">
                        <h4 class="fs-4 flex-grow-1 mb-0 text-end">
                            <span class="counter-value"> {{ unresolved_invoice }}</span>
                        </h4>
                        </div>
                    </div>
                    <router-link
                    :to="'/ar/invoices/invoice-creation/' + cust_id"
                    custom
                    v-slot="{ navigate, href }"
                    >
                    <button
                        :disabled="!canCreateInvoices"
                        class="mt-auto w-100 btn-lg"
                        :class="canCreateInvoices ? 'btn-warning' : 'btn-danger disabled opacity-50'"
                        style="font-size: 16px; background-color: #FF7F41;"
                        :href="href"
                        @click="navigate"
                    >
                        Create Invoice
                    </button>
                    </router-link>
                </div>
                <!-- end card body -->
            </div>
        </div>

        <div class="col-xl-3">
            <div class="card card-animate flex-fill h-100">
                <div class="card-body d-flex flex-column">
                <p class="align-items-center text-uppercase fw-medium text-muted text-truncate mb-3" style="font-size: 16px;">
                        Unresolved Credit Notes
                    </p>
                    <div class="row d-flex align-items-center mb-3">
                        <div class="col-sm-12">
                        <h4 class="fs-4 flex-grow-1 mb-0 text-end">
                            <span class="counter-value"> {{ late_payment }}</span>
                        </h4>
                        </div>
                    </div>
                    <router-link
                    :to="'/ar/credit_notes/create/' + cust_id"
                    custom
                    v-slot="{ navigate, href }"
                    >
                    <button
                        :disabled="!canCreateCreditNotes"
                        class="mt-auto w-100 btn-lg"
                        :class="canCreateCreditNotes ? 'btn-primary' : 'btn-primary disabled opacity-50'"
                        style="font-size: 16px;"
                        :href="href"
                        @click="navigate"
                    >
                        Create Credit Note
                    </button>
                    </router-link>
                </div>
                <!-- end card body -->
            </div>
        </div>

        <div class="col-xl-3">
            <div class="card card-animate flex-fill h-100">
                <div class="card-body d-flex flex-column">
                <p class="align-items-center text-uppercase fw-medium text-muted text-truncate mb-3" style="font-size: 16px;">
                        Refundable amount
                    </p>
                    <div class="row d-flex align-items-center mb-3">
                        <div class="col-sm-12">
                        <h4 class="fs-4 flex-grow-1 mb-0 text-end">
                            <span class="counter-value">RM {{ over_pay }}</span>
                        </h4>
                        </div>
                    </div>
                    <router-link
                    :to="'/ar/refund/create/' + cust_id"
                    custom
                    v-slot="{ navigate, href }"
                    >
                    <button
                        :disabled="!canCreateRefunds"
                        class="mt-auto w-100 btn-lg"
                        :class="canCreateRefunds ? 'btn-warning' : 'btn-warning disabled opacity-50'"
                        style="font-size: 16px;"
                        :href="href"
                        @click="navigate"
                    >
                        Create Refund
                    </button>
                    </router-link>
                </div>
                <!-- end card body -->
            </div>
        </div>
    </div>
</template>